<style lang="less" scoped>
  .ivu-menu{
    height: 100%;
    padding-left: 0 !important;
    /deep/ .ivu-menu {
      padding-left: 0 !important;
    }
    .menu-list-container {
      height: calc(100% - 52px);
      overflow-y: auto;
    }
  }
  .layout-text{
    display: inline-block;
    vertical-align: middle;
  }
  .layout-search {
    padding: 10px;
    box-shadow: inset 0 0 2px #2a2f32;
  }
</style>
<template>
  <Menu
    ref="menu"
    theme="dark"
    width="auto"
    :active-name="active_name"
    @on-select="goTo"
  >
    <template>
      <div class="layout-search">
        <Input
          v-model="searchdata"
          class="layout-search-input"
          enter-button
          placeholder="搜索关键字, 例如: 申请 shenqi sq"
          clearable
          :value="searchdata"
          @on-clear="changeSearch"
          @on-change="changeSearch(searchdata)"
        />
      </div>
    </template>
    <MenusItemSpecial
      id="sidebar-menu"
      class="menu-list-container"
      :menu-list="menuList"
      :show-hash-map="showHashMap"
      :bage-count="bage_count"
    />
  </Menu>
</template>
<script>
  import {addShowHash, filtrateShow, getLevel0Name} from '../../../libs/menus_util'
  import MenusItemSpecial from './components/Item'
  import {goFromMenus} from '../../../libs/router_util'

  const SCROLL_OPTIONS = {
    container: '#sidebar-menu',
    duration: 300,
    offset: 200,
    easing: 'easeInOutCubic',
  }

  export default {
    components: { MenusItemSpecial },
    props: {
      menus: {
        type: Array,
        default:() => []
      }
    },
    data() {
      return {
        active_name: '',
        pending_count: {
          bx: 0,
          fk: 0,
          yz: 0,
          cz: 0,
          contract: 0,
          business_total: 0
        },
        stock_count: {},
        wage_count: {},
        kingdee_sync_failed_count: 0,
        show_hash: {},
        searchdata:'',
        hasChildrenName:{},
      }
    },
    computed: {
      showHashMap() {
        if (!this.searchdata.trim()) {
          // 筛选条件为空时
          // 显示侧边栏的每一个条目
          Object.keys(this.show_hash).forEach(key => {
            this.show_hash[key] = true
          })
          if (this.$refs.menu) {
            const _this = this
            /* eslint-disable */
            requestAnimationFrame(() => {
              const { openedNames=[] } = _this.$refs.menu
              for (const value of openedNames) {
                _this.$refs.menu.updateOpenKeys(value)
              }
            })
          }

        } else {
          const selectHashMap = filtrateShow(this.searchdata.toLowerCase(),this.menus)
          Object.keys(this.show_hash).forEach(id => {
            this.show_hash[id] = !!selectHashMap[id] // 展示项
            if(this.hasChildrenName[id]&&!!selectHashMap[id]) { // 展开项
              const _this = this
              requestAnimationFrame(() => {
                const openedNames = _this.$refs.menu.openedNames || []
                const _id = parseInt(id)
                if(!openedNames.includes(_id)) {
                  _this.$refs.menu.updateOpenKeys(_id)
                }
              });
            }
          })
        }
        return this.show_hash
      },
      menuList () {
        return this.menus
      },
      customer (){
        const base = {
          groups: [],
          is_director: false,
          is_outsource_director: false,
          is_team_leader: false,
          is_formal: false
        };
        return Object.assign(base, this.$store.state.cur_customer);
      },
      is_login (){
        return !!this.customer.id;
      },
      bage_count() {
        return this.$store.state.red_dot_hash
      },
      path_hash() {
        return this.$store.state.path_hash;
      }
    },
    created (){
      this.initEvents();
    },
    beforeDestroy() {
      this.offEvents();
    },
    methods: {
      changeSearch (data) {
        this.searchdata = data || ''
      },
      initEvents (){
        eventHub.$on('check-route-auth', this.checkRouteAuth);
        eventHub.$on('go-to-path', this.goToPath);
      },
      offEvents() {
        eventHub.$off('check-route-auth', this.checkRouteAuth);
        eventHub.$off('go-to-path', this.goToPath);
      },
      checkRouteAuth (to){
        if(this.is_login){
          // if(true){
          //     // const valid = this.inGroup.apply(this, groups);
          //     console.log('check groups: ', valid,);
          //     if(!valid){
          //         this.goTo('/common/forbidden');
          //     }
          // }
          // if(auths){
          //     // const valid = this.hasAuths(auths);
          //     console.log('check auths: ', valid, auths);
          //     if(!valid){
          //         this.goTo('/common/forbidden');
          //     }
          // }
        }else{
          clearTimeout(this.checkRouteAuthTimer);
          this.checkRouteAuthTimer = setTimeout(() => {
            this.checkRouteAuth(to);
          }, 500);
        }
      },
      inGroup (){
        const len = arguments.length;
        for(let i = 0; i < len; i++){
          if(this.customer.groups.indexOf(arguments[i]) > -1){
            return true;
          }
        }
        return false;
      },
      hasAuths (auths=[]){
        const len = auths.length;
        for(let i = 0; i < len; i++){
          if(this.customer[auths[i]]){
            return true;
          }
        }
        return false;
      },
      activeMenuItem(path) {
        const item = this.path_hash[path];
        if (!item) return;
        this.active_name = item.id;
        const opened_names = this.$refs.menu.openedNames;
        const should_opened_name = item.parent_id;
        const already_opened = opened_names.includes(should_opened_name);
        if (!already_opened) {
          this.$refs.menu.updateOpenKeys(should_opened_name);
        }
        // scroll to active name
        setTimeout(() => {
          const menu_selector = `#menu-${item.id}`;
          const active_menu_el = document.querySelector(menu_selector);
          if (active_menu_el) {
            this.$vuetify.goTo(active_menu_el, SCROLL_OPTIONS);
          }
        }, 300);
      },
      goToPath(path) {
        const item = this.path_hash[path];
        if (item) {
          this.goTo(item.id);
          this.activeMenuItem(path);
        } else {
          throw `未找到${path}对应的路由`;
        }
      },
      goTo(key) {
        goFromMenus(key,this.$store.state.menu_id_hash,this.$router)
      },
    },
    beforeMount() {
      addShowHash(this.menus,this.show_hash,this.$set)
      this.hasChildrenName =  getLevel0Name(this.menus)
    },
    mounted() {
      this.activeMenuItem(window.location.pathname);
    }
  }
</script>
